import React from "react";
import { PromoVideo } from "@/components/PromoVideo";
import { ASSETS, FEATURES } from "@/data/landing";
import { Reveal } from "@/components/landing/primitives";

export const AppSection = () => (
  <section id="app" data-testid="app-section" className="py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-sm tracking-wider uppercase font-semibold text-afwn-green">The App</p>
          <h2 className="mt-3 font-heading font-light tracking-tight text-4xl lg:text-5xl">Experience app.anxiety-fix.com</h2>
          <p className="mt-4 text-lg text-afwn-slate">Everything you need for your wellness journey — beautifully in one place, on your phone or laptop.</p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[ASSETS.video1, ASSETS.video2, ASSETS.video3].map((v, i) => (
          <Reveal key={v} i={i}>
            <PromoVideo src={v} poster={`/posters/video-${i + 1}.jpg`} index={i + 1} />
          </Reveal>
        ))}
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} i={i}>
            <div className="bg-white border border-afwn-navy/5 rounded-3xl p-7 h-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
              <div className="w-12 h-12 rounded-2xl bg-afwn-green/10 flex items-center justify-center text-afwn-green">
                <f.icon size={24} />
              </div>
              <h3 className="mt-4 text-lg font-medium">{f.title}</h3>
              <p className="mt-2 text-sm text-afwn-slate leading-relaxed">{f.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
